import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Send, Paperclip, AlertCircle } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const SendEmailDialog = ({ quote }) => {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) api.get(`/quotations/${quote.id}/email-info`).then((r) => setInfo(r.data));
  }, [open, quote.id]);

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/quotations/${quote.id}/send-email`);
      toast.success(`Penawaran terkirim ke ${data.to}`);
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="bg-white" data-testid="detail-email-btn"><Mail className="h-4 w-4 mr-1" />Kirim Email</Button>
      </DialogTrigger>
      <DialogContent aria-describedby={undefined} className="max-w-lg">
        <DialogHeader><DialogTitle className="font-heading text-xl">Kirim Penawaran via Email</DialogTitle></DialogHeader>
        {!info ? <p className="text-sm text-slate-400">Memuat...</p> : (
          <div className="space-y-4">
            <div className="rounded-lg bg-slate-50 p-4 text-sm space-y-1.5">
              <p><span className="text-slate-500">Kepada:</span> <b data-testid="email-recipient">{info.to || "-"}</b></p>
              <p><span className="text-slate-500">PIC:</span> {info.pic_name || "-"} • {info.customer_name}</p>
              <p><span className="text-slate-500">Subjek:</span> Penawaran Harga {quote.display_no}</p>
              <p className="flex items-center gap-1.5 text-slate-600"><Paperclip className="h-3.5 w-3.5" />Lampiran PDF + link unduh (berlaku 7 hari)</p>
            </div>
            {!info.to && (
              <div className="flex gap-2 rounded-lg bg-amber-50 p-3 text-sm text-amber-800" data-testid="email-missing-warning">
                <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
                <span>Email PIC belum diisi di data customer. <Link to="/customers" className="font-semibold underline">Lengkapi di menu Customer</Link>.</span>
              </div>
            )}
            {info.history?.length > 0 && (
              <div className="text-xs text-slate-500" data-testid="email-history">
                <p className="font-semibold uppercase tracking-wider mb-1">Riwayat kirim</p>
                {info.history.slice(-5).reverse().map((h, i) => <p key={i}>{fdate(h.sent_at)} • {h.to} • oleh {h.by}</p>)}
              </div>
            )}
            <Button className="w-full h-11" disabled={!info.to || busy} onClick={send} data-testid="email-send-btn">
              <Send className="h-4 w-4 mr-2" />{busy ? "Mengirim..." : "Kirim Sekarang"}
            </Button>
            <p className="text-[11px] text-slate-400">Balasan customer akan masuk ke email sales pembuat penawaran.</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
